import { render, staticRenderFns } from "./VisitorDetails.vue?vue&type=template&id=2ea69cf9&"
import script from "./VisitorDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./VisitorDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports